<div *ngIf="isLoading" style="display:flex;">
    <div class="spinner spinner-lg spinner-success"></div>
    <div style="margin-left: 30px;">Zubehör prüfen</div>
</div>
<div *ngIf="!isLoading">
    <mat-divider class="p-2 mt-2"></mat-divider>
    <div class="zub_headerarea">
        <div style="width:50%">
            <div class="headline">Zubehör</div>
        </div>
        <div style="width:50%; text-align: right;">
            <div (click)="toggledisplayheight();" matTooltip="aufklappen">
                <div class="btn_expandview"></div>
            </div>
        </div>
    </div>
    <div class="zub_artikel_list">        
        <div *ngFor="let zub_artikel of artikel" class="zub_artikelcard" [ngClass]="{'matrix': zub_artikel.matrixArtikel_JN != 'N'}">
            <div style="font-weight: bold;">{{zub_artikel.name}}<br></div>
            <div>{{zub_artikel.name2}}<br></div>

            <div style="display: flex;">
                <div style="width: 50%;">
                    <div *ngIf="zub_artikel.bildKlein != null" class="cardimage">
                        <img src="data:image/jpeg;base64,{{zub_artikel.bildKlein}}" />
                    </div>
            
                    <div *ngIf="zub_artikel.bildKlein == null" class="cardimage">
                        <img src="{{imgDummy}}" style="opacity: 10%;" />
                    </div>
                </div>
                <div style="width: 50%;">
                    <!-- Bestand -->
                    <div class="col" align="right" *ngIf="zub_artikel.bestand > 0">
                        <span class="material-icons matIcon-md" style="color:#34dd34"
                            matTooltip="Artikel auf Lager {{zub_artikel.bestand}}">
                            fiber_manual_record
                        </span>
                    </div>
                    <div class="col" align="right" *ngIf="zub_artikel.bestand <= 0">
                        <span class="material-icons matIcon-md" style="color:#ff0000" matTooltip="Artikel nicht auf Lager, Ware wird bestellt">
                            fiber_manual_record
                        </span>
                    </div>

                    <!-- Buttons -->
                    <div>
                        <button mat-icon-button class="btn" aria-label="Card-Basket" *ngIf="zub_artikel.artikelZubehoerMenge != 1"
                            (click)="(zub_artikel.matrixArtikel_JN == 'J' ? onSelectMatrix(zub_artikel,zub_artikel.artikelZubehoerMenge*zubehoermulti) : onAddToWarenkorb(zub_artikel,zub_artikel.artikelZubehoerMenge*zubehoermulti,false)); $event.stopPropagation()"
                            matTooltip="vorgeschl. Menge ({{zub_artikel.artikelZubehoerMenge * zubehoermulti}}) in den Warenkorb">
                            <i class="flaticon2-shopping-cart-1 icon-lg all_zub"></i>
                            {{zub_artikel.artikelZubehoerMenge * zubehoermulti}}
                        </button>

                        <button mat-icon-button class="btn" aria-label="Card-Basket" (click)="(zub_artikel.matrixArtikel_JN == 'J' ? onSelectMatrix(zub_artikel,1 * zubehoermulti) : onAddToWarenkorb(zub_artikel,1* zubehoermulti,false)); $event.stopPropagation()" matTooltip="In den Warenkorb">
                            <i class="flaticon2-shopping-cart-1 icon-lg"></i>
                            {{zubehoermulti}}
                        </button>
                    </div>
                </div>
            </div>

            <div class="data">
                <div>Art.Nr.: {{zub_artikel.nr}}<br></div>
                <div>Hersteller-Nr.: {{zub_artikel.herstellerNr}}<br></div>
                <!-- <div>Infos.: weitere Felder</div> -->
            </div>
        </div>
    </div>
</div>